import { createContext, useContext, type ReactNode } from 'react';
import { usePrayerUnread, type PrayerUnreadResult } from '@/hooks/usePrayerUnread';

/**
 * Single app-wide instance of the prayer unread listeners — powers the
 * Prayers nav badge, the prayer sidebar badges, and mark-seen writes
 * without duplicating Firestore listener sets across consumers.
 */
const PrayerUnreadContext = createContext<PrayerUnreadResult | undefined>(undefined);

export function PrayerUnreadProvider({ children }: { children: ReactNode }) {
  const value = usePrayerUnread();
  return <PrayerUnreadContext.Provider value={value}>{children}</PrayerUnreadContext.Provider>;
}

export function usePrayerUnreadContext(): PrayerUnreadResult {
  const context = useContext(PrayerUnreadContext);
  if (context === undefined) {
    throw new Error('usePrayerUnreadContext must be used within PrayerUnreadProvider');
  }
  return context;
}
